import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.25 7.07546L12.9314 2.55187C12.5963 2.31199 12.4288 2.19204 12.246 2.14565C12.0845 2.10469 11.9154 2.10469 11.754 2.14565C11.5712 2.19204 11.4037 2.31199 11.0686 2.55187L4.74997 7.07548M19.25 7.07546L21.5 8.68627M19.25 7.07546V12.6851M4.74997 7.07548V16.6851C4.74997 17.8052 4.74997 18.3653 4.96796 18.7931C5.15971 19.1694 5.46567 19.4754 5.84199 19.6671C6.26982 19.8851 6.82987 19.8851 7.94997 19.8851H12.05M4.74997 7.07548L2.5 8.68627",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.5 16.6528L19.8521 17.0269M14.8708 19.9028L15.5187 19.5287M20.4999 19.9028L19.8521 19.5288M14.8707 16.6528L15.5187 17.0269M17.6854 21.5278V20.7153M17.6854 15.0278V15.8403M19.8521 18.2778C19.8521 17.8831 19.7465 17.513 19.5621 17.1943C19.1874 16.5468 18.4873 16.1111 17.6854 16.1111C16.8835 16.1111 16.1833 16.5468 15.8087 17.1943C15.6243 17.513 15.5187 17.8831 15.5187 18.2778C15.5187 18.6725 15.6243 19.0426 15.8087 19.3613C16.1834 20.0088 16.8835 20.4445 17.6854 20.4445C18.4873 20.4445 19.1874 20.0088 19.5621 19.3613C19.7465 19.0426 19.8521 18.6725 19.8521 18.2778Z",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }